import { Fragment } from 'react';

import { useSelector } from 'react-redux';

import classes from './CopyModal.module.css';

import close from '../../assets/img/closeIcon.svg';

const CopyModal = ({ hideModal }) => {
  const prefix = window.location.origin;
  const url = window.location.pathname;
  const data = useSelector((state) => state.optRed.data);

  return (
    <Fragment>
      <div className={classes.backdrop} onClick={hideModal}></div>
      <div className={classes.copyModal}>
        <div onClick={hideModal} className={classes.closeBtn}>
          <img src={close} alt="X" />
        </div>
        <div className={classes.copyDiv}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="92"
            fill="none"
            viewBox="0 0 92 92"
          >
            <path
              fill="#50AF78"
              d="M46 .168C20.7.168.167 20.701.167 46.001.167 71.301 20.7 91.835 46 91.835 71.3 91.835 91.833 71.3 91.833 46 91.833 20.701 71.3.168 46 .168zM33.58 65.664L17.124 49.21a4.564 4.564 0 010-6.463 4.564 4.564 0 016.462 0l13.246 13.2 31.534-31.533a4.564 4.564 0 016.462 0 4.564 4.564 0 010 6.462L40.042 65.664c-1.742 1.787-4.675 1.787-6.463 0z"
            ></path>
          </svg>
          <div className={classes.copyModal__text}>Copied to clipboard</div>
          <p style={{ marginBottom: '20px', border: '1.5px solid', borderRadius: '5px' }}>
            <a
              href={`${url}?isShortlisted=true`}
              target="_blank"
              rel="noopener noreferrer"
            >{`${prefix}${url}?isShortlisted=true`}</a>
          </p>
          <button
            className="button secondary"
            style={{ marginBottom: '20px', float: 'right', borderRadius: '5px' }}
            onClick={hideModal}
          >
            Close
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default CopyModal;
